import { SERVICE_CONFIG } from "./service";

// Centralized pricing configuration
export interface PricingFeature {
  text: string;
  link?: string;
}

export const PRICING = {
  // Original price (crossed out)
  originalPrice: 299,
  // Current discounted price
  currentPrice: 89.7,
  // Currency
  currency: 'RON',
  // Product details
  product: {
    name: 'Cântecel Personalizat',
    description: 'O melodie creată special pentru un copil drag',
  },
  // Features included
  features: [
    { text: 'Versuri originale inspirate din povestea copilului' },
    { text: 'Producție audio profesională' },
    { text: 'Fișier MP3 de înaltă calitate' },
    { text: `Livrare în ${SERVICE_CONFIG.deliveryDaysText}` },
    { text: 'Suport pentru întrebări' },
    { text: 'Compatibil cu Yoto Player', link: '/yoto/despre' },
  ] satisfies PricingFeature[],
} as const;
